import { render, staticRenderFns } from "./CircRnaGoKegg.vue?vue&type=template&id=6ff700c9&scoped=true"
import script from "./CircRnaGoKegg.vue?vue&type=script&lang=js"
export * from "./CircRnaGoKegg.vue?vue&type=script&lang=js"
import style0 from "./CircRnaGoKegg.vue?vue&type=style&index=0&id=6ff700c9&prod&scoped=true&lang=css"
import style1 from "./CircRnaGoKegg.vue?vue&type=style&index=1&id=6ff700c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff700c9",
  null
  
)

export default component.exports